export const slugifySystemName = (name = '') =>
  name
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

const mapApiRecordToSystem = (systemRecord) => ({
  id: systemRecord.system,
  name: systemRecord.system,
  patientCount: Number(systemRecord.patient_count ?? 0),
});

export const mapSystemsResponse = (response) => {
  if (!response || !Array.isArray(response.systems)) {
    return [];
  }

  return response.systems
    .filter((record) => record && record.system)
    .map(mapApiRecordToSystem);
};

export const findSystemBySlug = (systems, slug) =>
  systems.find((system) => slugifySystemName(system.name) === slug);
